import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { parseQuery } from './helpers';
import Home from './packages/Home';
import HyperModal from './packages/HyperModal';
import HyperTree from './packages/HyperTree'
import './App.css';

const packagesMapper = {
  'home': Home,
  'hyper-modal': HyperModal,
  'hyper-tree': HyperTree,
};

class App extends Component {
  render() {
    const { location: { search } } = this.props;
    const packageType = parseQuery(search).package || 'home';
    const PackageComponent = packagesMapper[packageType];
    return (
      <PackageComponent />
    );
  }
}

export default withRouter(App);
